import { useFormContext } from 'react-hook-form'

import useExtraFormContext from './useExtraFormContext'
import { InputProps } from '../interfaces'

export default function useIsDisabled(
  props: InputProps,
  isUnavailable?: boolean
): any {
  const { disabled } = props
  const { autoSubmitEnabled, formIsDisabled } = useExtraFormContext() || {}

  const ctx = useFormContext()
  let isDisabled
  if (!!disabled) {
    isDisabled = true
  } else if (!!formIsDisabled) {
    isDisabled = true
  } else if (!!isUnavailable) {
    isDisabled = true
  } else if (!!autoSubmitEnabled) {
    isDisabled = false
  } else if (!!ctx.formState.isSubmitting) {
    isDisabled = true
  }
  return isDisabled
}
